<mat-chip class={{this.class}}>
  <mat-icon *ngIf="prefixIcon" class="chip-icon chip-button" [fontIcon]="!isPrefixIconSvg ? prefixIcon : ''" [svgIcon]="isPrefixIconSvg ? prefixIcon : ''">{{ prefixIcon }}</mat-icon>
  <ng-content></ng-content>
  {{ text }}
  <mat-icon *ngIf="suffixIcon" class="chip-icon chip-button" [fontIcon]="!isSuffixIconSvg ? suffixIcon : ''" [svgIcon]="isSuffixIconSvg ? suffixIcon : ''"></mat-icon>
</mat-chip>
